<samplicity-file-input-wrapper #inputWrapper *ngIf="canEdit" [acceptsTypes]="acceptsTypes"
  [allowOverwrites]="allowOverwrites"
  [name]="fileControlName" [buttonLabel]="uploadButton" [parentFormGroup]="parentFormGroup"
  (delete)="clearAttachment()" (upload)="onUpload()" (duplicateFileName)="onDuplicateFileName()" [existingAttachments]="existingAttachments">
</samplicity-file-input-wrapper>
<div class="d-flex">
  <!-- <ng-container *ngIf="isDuplicateFileName">
    <small class="invalid-feedback d-flex align-items-middle field-errors" [style.display]="'block'" role="alert">
      <mat-icon color="danger">error</mat-icon>
      <span l10nTranslate>{{duplicateFileNameMessage}}</span>
    </small>
  </ng-container> -->
  <samplicity-text-inline-input *ngIf="isImageUploaded && !isDuplicateFileName && !showDuplicateNameError" [label]="descLabel"
    [name]="descControlName" [maxLength]="descMaxLength" [parentFormGroup]="parentFormGroup">
  </samplicity-text-inline-input>

  <div *ngIf="isImageUploaded && isImageDescriptionFilled && !isDuplicateFileName && !showDuplicateNameError">
    <button class="attach-file-button mat-raised-button mat-white" type="button" 
      (click)="createAttachment()">
      <span class="mat-button-wrapper">
      <mat-icon>attach_file</mat-icon>
      <span l10nTranslate>{{attachButton}}</span>
      </span>
    </button>
  </div>
</div>